import { useSignUpFlowStore } from '@energy-retailer/state-store';
import { deleteCookie } from 'cookies-next';

import {
  PROMO_TERMS_URL_COOKIE,
  PROMO_TITLE_COOKIE,
  PROMO_ID_COOKIE,
  INVITE_CODE_COOKIE,
  EXIT_MODAL_PATH_COOKIE,
} from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

export const useResetPersistedState = () => {
  const { reset: resetSignupFlowStore } = useSignUpFlowStore();
  const {
    resetCheckbox,
    resetModals,
    resetSteps,
    resetProperty,
    resetCart,
    resetPromotion,
    resetFlow,
  } = useJoinFormStore();

  function resetPersistedState() {
    // Zustand store and session storage reset
    resetSignupFlowStore();
    resetCheckbox();
    resetModals();
    resetSteps();
    resetProperty();
    resetCart();
    resetPromotion();
    resetFlow();

    // Delete cookies
    deleteCookie(PROMO_ID_COOKIE);
    deleteCookie(PROMO_TITLE_COOKIE);
    deleteCookie(PROMO_TERMS_URL_COOKIE);
    deleteCookie(INVITE_CODE_COOKIE);
    deleteCookie(EXIT_MODAL_PATH_COOKIE);
  }

  return {
    resetPersistedState,
  };
};
